export class Order {
  constructor(shopList, tableGuid) {
    this.shopList = shopList;
    this.tableguid = tableGuid;
  }

  serialize() {
    const order = {
      orders: [],
      table_guid: this.tableguid
    };
    Object.entries(this.shopList).forEach(([key, item]) => {
      order.orders.push({
        product_guid: key,
        qty: item.qty,
        comment: item.comments
      });
    });
    return order;
  }
}
